<div class="backdrop">
  <div class="justify-center items-center flex-col px-6 rounded-lg py-2 flex">
    <img
      src="../../../../assets/images/nsc-logo.png"
      alt="Loading"
      class="loader-image"
    />
    <div class="loader-text !flex !items-center">
      <span class="font-medium"> {{ gen.msg || "Loading, please wait" }} </span>
      <div class="dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  </div>
</div>
